import {MdOutlineClose} from 'react-icons/md';
import {BiCurrentLocation} from 'react-icons/bi';
import {BiChevronLeft} from 'react-icons/bi';
import "./locationdrawer.css";

const LocationDrawer = ({closeDrawer}) => {
  return (
    <div className="location_drawer">
      <div className="choose_city mb-4">
      <span>انتخاب شهر</span>
        <MdOutlineClose
        size={23} color='#080a38'
        onClick={() => closeDrawer(false)}
        className='close_loc'
        />
      </div>
      <div className='location_all-city'>
        <div className='auto_loc mb-4'>
            <BiCurrentLocation color='#19bfd3' size={22}/>
            <span>مکان یابی خودکار</span>
        </div>
        <div className='city_loc'>
            <div className='city_name mb-3'>
                <span>آذربایجان شرقی</span>
                <BiChevronLeft size={25} color='#3f4064'/>
            </div>
            <div className='city_name mb-3'>
                <span>آذربایجان شرقی</span>
                <BiChevronLeft size={22}/>
            </div>
            <div className='city_name mb-3'>
                <span>آذربایجان شرقی</span>
                <BiChevronLeft size={22}/>
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default LocationDrawer;
